/**
 * Get unique locale variations list from a content object
 *
 * @param {object} content - Content object from a step child
 * @return {array} List of founded locales ids in variations
 */
export function getLocaleVariations(content) {
  if (!content || typeof content !== 'object') return [];

  return [
    ...new Set(
      Object.keys(content).flatMap(key => {
        if (key === 'variations') {
          return Object.keys(content[key]);
        }

        return getLocaleVariations(content[key]);
      })
    ),
  ];
}
